export const defaultTemplateId: number = -1
